import type { AppModule } from "../types";
import { s } from "./strings";

export const timeTrackerModule: AppModule = {
  name: "time-tracker",
  routes: {
    shell: [
      {
        path: "/tracker",
        handle: { title: s.pageTitle },
        lazy: () => import("./pages/TrackerPage").then((m) => ({ Component: m.TrackerPage })),
      },
    ],
  },
  sidebar: [
    {
      id: "TIME_TRACKER",
      label: "Time tracker",
      path: "/tracker",
      icon: "tracker",
      alt: "View Time tracker",
      // "Hide time tracker view" (canSeeTracker=false) hides the page (spec 2.1, 11.5).
      visible: (ctx) => ctx.workspaceSettings.canSeeTracker !== false,
    },
  ],
};
